const allElementsString = arr => {
  return arr.every(elem => typeof elem === 'string');
};

const allElementsNumbers = arr => {
  return arr.every(elem => typeof elem === 'number');
};

const formatArray = params => {
  if (params.length <= 0) {
    params = [];
  } else if (allElementsString(params) || allElementsNumbers(params)) {
    params = [...params];
  } else {
    params = params.map(val => val.id);
  }
  return params;
};

const generatePayloadForObject = item => {
  if (item.action_params.id) {
    item.action_params = [item.action_params.id];
  } else {
    item.action_params = [item.action_params];
  }
  return item.action_params;
};

// Actions whose action_params are already structured objects
// (e.g. [{ inbox_id, template_params, fallback_inbox_id }]) and must NOT be
// reduced via .map(val => val.id).
const STRUCTURED_PARAM_ACTIONS = new Set([
  'send_whatsapp_template',
  'send_email',
  'send_sms',
  'run_macro',
  'update_contact',
]);

const generatePayload = data => {
  const actions = JSON.parse(JSON.stringify(data));
  let payload = actions.map(item => {
    if (STRUCTURED_PARAM_ACTIONS.has(item.action_name)) {
      // Pass through as-is; backend expects [{ ...config }]
      if (!Array.isArray(item.action_params)) {
        item.action_params = item.action_params ? [item.action_params] : [];
      }
      return item;
    }
    if (Array.isArray(item.action_params)) {
      item.action_params = formatArray(item.action_params);
    } else if (typeof item.action_params === 'object') {
      item.action_params = generatePayloadForObject(item);
    } else if (!item.action_params) {
      item.action_params = [];
    } else {
      item.action_params = [item.action_params];
    }
    return item;
  });
  return payload;
};

export default generatePayload;
